import { qspost} from '@/plugins/axios'

/*
 * 登录
 * */
export const login = (phone,password) => qspost('api/login/login', {phone,password})

/*
 * 手机短信快捷登陆
 * */
export const sms_login = (phone, code) => qspost('api/login/sms_login', {phone, code})

/*
 * 发送短信验证码
 * @type 0登陆
 * */
export const sendPhoneCode = (phone,type = 0) => qspost('/index/Login/sms_send', {phone,type})

/*
 * 易魔方跳转登录
 * */
export const emof_login = (token) => qspost('api/login/Synchronouslogin', {token})